import { Stack, Typography, useTheme } from "@mui/material";
import { truncateString } from "helpers/stringHelper";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  StyledAccordion,
  StyledAccordionSummary,
  LessonNameBox,
  UnderlinedTypography,
  PercentageBox,
  StyledLinearProgress,
  PointsPlaceholderBox
} from "./SimpleLessonComponent.styles";

export const SimpleLessonComponent = ({ lessonName, index }: { lessonName: string, index: number }) => {
    const theme = useTheme();
  
    return (
        <StyledAccordion key={index} expanded={false}>
            <StyledAccordionSummary
            aria-controls="panel1d-content"
            id="panel1d-header"
            expandIcon={<ExpandMoreIcon />}
            >
                <Stack direction={'row'} width={'100%'} display={'flex'} justifyContent={'space-between'} paddingLeft={theme.spacing(2)} alignItems={'center'}>
                    <LessonNameBox>
                    <UnderlinedTypography>{truncateString(lessonName, 25)}</UnderlinedTypography>
                    </LessonNameBox>
                    <PercentageBox sx={{ paddingLeft: theme.spacing(2), paddingRight: theme.spacing(2) }}>
                    <Typography>{'0 %'}</Typography>
                    </PercentageBox> 
                    <StyledLinearProgress variant="determinate" value={0} />
                    <PointsPlaceholderBox />
                </Stack>
            </StyledAccordionSummary>
        </StyledAccordion>
    );
  }